/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const updateEmailTemplateDataSchema = z.object({
	name: z.string().nullable().optional(),
	subject: z.string().nullable().optional(),
	body: z.string().nullable().optional(),
})

export type UpdateEmailTemplateDataSchema = z.infer<typeof updateEmailTemplateDataSchema>
